export const rootRedirectLoader = () => {
  window.location.replace(process.env.REACT_APP_HOME);
  return null;
};
